import { Injectable } from '@angular/core';
// Translate Service
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TranslationService {

  lang: string;

  constructor(private translate: TranslateService) {
    // tslint:disable-next-line:prefer-const
    this.lang = localStorage.getItem('lang');
    if ( this.lang ) {
      translate.setDefaultLang(this.lang);
    } else {
      this.lang = 'es';
      translate.setDefaultLang('es');
    }
  }

  switchLanguage(language: string) {
    this.lang = language;
    localStorage.setItem('lang', language);
    this.translate.use(language);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/translation/translation.service.ts